import { useState, useCallback, useEffect } from 'react';

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedElement, setSelectedElement] = useState(null);

  const showContextMenu = useCallback((event, element) => {
    event.preventDefault();
    event.stopPropagation();

    setContextMenu({
      x: event.clientX,
      y: event.clientY,
    });
    setSelectedElement(element);
  }, []);

  const hideContextMenu = useCallback(() => {
    setContextMenu(null);
    setSelectedElement(null);
  }, []);

  useEffect(() => {
    const handleClick = () => hideContextMenu();
    const handleScroll = () => hideContextMenu();

    if (contextMenu) {
      document.addEventListener('click', handleClick);
      document.addEventListener('scroll', handleScroll, true);

      return () => {
        document.removeEventListener('click', handleClick);
        document.removeEventListener('scroll', handleScroll, true);
      };
    }
  }, [contextMenu, hideContextMenu]);

  return {
    contextMenu,
    selectedElement,
    showContextMenu,
    hideContextMenu,
  };
};
